let enabled = false

const setEnabled = (isEnabled) => {
  enabled = isEnabled
}

const isEnabled = () => enabled

export { setEnabled, isEnabled }
